import axios from './BaseService';

const URL = `${process.env.REACT_APP_API_URL}/settings/custody-pages`;

export async function getCustodyPages() {
    const response = await axios.get(URL);
    return response.data;
}

export async function saveCustodyPages(access) {
    const response = await axios.patch(URL, { access });
    return response.data;
}
